export default angular.module('eventix.common.services.vat', [])
    .provider('Vat', function() {
        const provider = this;
        const OTHER_VAT_RATE = {
            other: null
        };
        const DEFAULT_VAT_RATES = {
            none: 0,
            reduced: 9,
            normal: 21,
            other: OTHER_VAT_RATE.other
        };
        const VAT_RATES = {
            NL: {
                none: 0,
                reduced: 9,
                normal: 21
            },
            BE: {
                none: 0,
                reduced: 6,
                normal: 21
            },
            DE: {
                none: 0,
                reduced: 7,
                normal: 19
            },
            UK: {
                none: 0,
                reduced: 5,
                normal: 20
            }
        };

        provider.$get = /*@ngInject*/function() {
            const Vat = {};
            let globalCountryCode = 'nl_NL';
            Object.defineProperties(Vat, {
                setCountryCode: {
                    value: function(code) {
                        globalCountryCode = code;
                    },
                    enumerable: false
                },

                getCountryCode: {
                    value: function() {
                        return globalCountryCode;
                    },
                    enumerable: false
                },
                getOtherVatRate: {
                    value: () => {
                        return OTHER_VAT_RATE;
                    },
                    enumerable: true
                },
                getAllVatRates: {
                    value: () => {
                        return VAT_RATES;
                    },
                    enumerable: true
                },
                getDefaultVatRates: {
                    value: () => {
                        return DEFAULT_VAT_RATES;
                    },
                    enumerable: true
                },
                getDefaultRateFor: {
                    value: (countryCode) => {
                        let rates = _.get(VAT_RATES, countryCode, DEFAULT_VAT_RATES);
                        let max = 0;
                        _.forEach(rates, function(value){
                            max = (value > max) ? value : max;
                        });
                        console.log(max);
                        return max;
                    },
                },
                getDefaultRate: {
                    value: () => {
                        let rates = _.get(VAT_RATES, globalCountryCode, DEFAULT_VAT_RATES);
                        let max = 0;
                        _.forEach(rates, function(value){
                            max = (value > max) ? value : max;
                        });
                        return max;
                    },
                }
            });

            return Vat;
        };
    }).name;
